// This function helps us avoid including lots of console.warn messages in our production bundle.
// This is only needed when we only want to *warn* in production rather than throwing an error.
// If you want to throw an error in production, use `tiny-invariant` instead.
export function invariantFailedProductionWarning() {
    console.warn('Invariant failed (run in dev mode to see details)')
}
